import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ContentLoaderComponent } from './content-loader.component';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';

@NgModule({
	imports: [CommonModule, IndicatorsModule],
	declarations: [ContentLoaderComponent],
	exports: [ContentLoaderComponent]
})
export class ContentLoaderModule {}
